
export function buildTimePeriodOpeningMarkdown(
  userFirstName: string,
  companyName: string,
): string {

  return `Hey **${userFirstName}**,\n
I've reviewed your request for the **${companyName}** share price analysis and the **Precedent Slide Frame** you selected.\n
Since adjusting **Time Periods** and **Benchmarks** significantly changes the results, I recommend producing a few variations of each slide to help you choose the best fit for your presentation.\n
My proposed variations are outlined below. Please let me know if you have a specific focus in mind; otherwise, click **Next** to proceed with this plan.\n

|  | Time Period (Dates) |  | Relative Benchmarks |  |  |
|--|--|--|--|--|--|
|  | **Start** | **Date** | **#1** | **#2** | **#3** |
| **Version 1** | 12/31/2019 | 3/23/2026 | Custom Index 1* | Dow Jones Software Index | S&P 500 |
| **Version 2** | 12/30/2022 | 3/23/2026 | Dow Jones Software Index | S&P 500 Information Technology | Nasdaq Composite Index |
| **Version 3** | 12/29/2023 | 3/23/2026 | Russell 2000 Index | Bloomberg Technology Index | MSCI World Technology Index |

*\\*Custom Index 1 is an equal weighted index made up of the following companies: Box, Docusign, Zoom, Asana, Microsoft, Adobe.*`;
}

export function buildNewPrecedentTimePeriodOpeningMarkdown(
  userFirstName: string,
  companyName: string,
): string {

  return `Hey **${userFirstName}**,\n
I've reviewed your request for the **${companyName}** share price analysis and the **Precedent Slide Frame** you selected. \n
Since adjusting **Time Periods** and **Benchmarks** significantly changes the results, I recommend producing a few variations of each slide to help you choose the best fit for your presentation. \n
My proposed variations are outlined below. Please let me know if you have a specific focus in mind; otherwise, click **Next** to proceed with this plan. \n

|  | Time Period (Dates) | | Relative Benchmarks | | |
|--|--|--|--|--|--|
|  | **Start** | **Date** | **#1** | **#2** | **#3** |
| **Version 1** | 12/31/2019 | 3/23/2026 | Custom Index 1* | N.A. | N.A. |
| **Version 2** | 12/30/2022 | 3/23/2026 | Dow Jones Software Index | N.A. | N.A. |
| **Version 3** | 12/29/2023 | 3/23/2026 | N.A. | N.A. | N.A. |

*\\*Custom Index 1 is an equal weighted index made up of the following companies: Box, Docusign, Zoom, Asana, Microsoft, Adobe.*`;
}
